import React, { Component } from 'react'
import { Row, Col } from 'reactstrap'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import Resx from '@/components/Resx'
import { WhiteBox } from '@/components/Layout'
import { defaultDateTimeSecondFormat, formatDate } from '@/utils/dateUtilities'
import PhoneNumber from '@/components/userProfile/phoneNumber'
import LegacyCode from '@/components/usersManagement/legacyCode'

const TwoFactorEnabledInfo = ({ user }) => {
  return <React.Fragment>
    <Resx name={user.isTwoFactorEnabled ? 'Common.Yes' : 'Common.No'} />
    {user.isTwoFactorEnabled && <span className='ml-1'> ({user.preferredTwoFactorProvider})</span>}
  </React.Fragment>
}
class Detail extends Component {
  render () {
    const { user, headerText, hideIsInternalUser, showMyPhone, canEditLegacyCode } = this.props

    if (!user) {
      return <React.Fragment />
    }

    return (
      <WhiteBox dataCy='UserManagementDetail' header={headerText || ''}>
        <Row>
          <Col lg='6'>
            <InfoRow>
              <InfoLabel><Resx name='UsersManagement.UserName' /></InfoLabel>
              <InfoContent>{user.userName}</InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='Common.Email' /></InfoLabel>
              <InfoContent>{user.emailAddress}</InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='Common.Phone' /></InfoLabel>
              <InfoContent>
                {showMyPhone && <PhoneNumber />}
                {!showMyPhone && <span className='phone-number'>{user.phoneNumber}</span>}
              </InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='Common.LegacyCode' /></InfoLabel>
              <InfoContent>
                {canEditLegacyCode && <LegacyCode userId={user.id} />}
                {!canEditLegacyCode && <span>{user.legacyCode}</span>}
              </InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='UsersManagement.CreationTime' /></InfoLabel>
              <InfoContent>{formatDate(user.creationTime, defaultDateTimeSecondFormat)}</InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='UsersManagement.LastModificationTime' /></InfoLabel>
              <InfoContent>{formatDate(user.lastModificationTime, defaultDateTimeSecondFormat)}</InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='UsersManagement.LockoutEndDateUtc' /></InfoLabel>
              <InfoContent>{formatDate(user.lockoutEndDateUtc, defaultDateTimeSecondFormat)}</InfoContent>
            </InfoRow>
          </Col>
          <Col lg='6'>
            <InfoRow>
              <InfoLabel><Resx name='UsersManagement.ApprovedAt' /></InfoLabel>
              <InfoContent>{formatDate(user.approvedAt)}</InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='UsersManagement.LastLoginTime' /></InfoLabel>
              <InfoContent>{formatDate(user.lastLoginTime, defaultDateTimeSecondFormat)}</InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='UsersManagement.AccessFailedCount' /></InfoLabel>
              <InfoContent>{user.accessFailedCount}</InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='UsersManagement.IsTwoFactorEnabled' /></InfoLabel>
              <InfoContent><TwoFactorEnabledInfo user={user} /></InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='UsersManagement.IsEmailConfirmed' /></InfoLabel>
              <InfoContent><Resx name={user.isEmailConfirmed ? 'Common.Yes' : 'Common.No'} /></InfoContent>
            </InfoRow>
            {!hideIsInternalUser &&
            <InfoRow>
              <InfoLabel><Resx name='UsersManagement.IsInternalUser' /></InfoLabel>
              <InfoContent><Resx name={user.isInternalUser ? 'Common.Yes' : 'Common.No'} /></InfoContent>
            </InfoRow>}
            <InfoRow>
              <InfoLabel><Resx name='UsersManagement.IsActive' /></InfoLabel>
              <InfoContent><Resx name={user.isActive ? 'Common.Yes' : 'Common.No'} /></InfoContent>
            </InfoRow>
          </Col>
        </Row>
      </WhiteBox>
    )
  }
}

export default Detail



// WEBPACK FOOTER //
// ./src/components/usersManagement/detail.js